import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take } from 'rxjs';
import {
  hasPendingB2cRedirect,
  hasPendingMsalInteraction,
  isFreshLoginCallback,
  isRoleSwitchInProgress,
} from '../../auth.config';

/** Default `/` handler — defers to MSAL when a B2C callback is present or being processed. */
@Component({
  selector: 'app-root-entry',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootEntryComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly msalService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    // Wait until MSAL has finished handleRedirect (login/logout processing).
    // Deciding earlier races the B2C callback: the hash is consumed but
    // JwtToken is not stored yet, which would bounce a fresh login back to firmlogin.
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        if (
          isRoleSwitchInProgress() ||
          hasPendingB2cRedirect() ||
          hasPendingMsalInteraction()
        ) {
          return;
        }
        const accounts = this.msalService.instance.getAllAccounts();
        const hasSession =
          !!sessionStorage.getItem('JwtToken') && accounts.length > 0;
        if (hasSession || isFreshLoginCallback() || accounts.length > 0) {
          // Post-MFA: MSAL account exists; app.component completes token + routing.
          this.router.navigateByUrl('/advisor-dashboard', { replaceUrl: true });
          return;
        }
        this.router.navigateByUrl('/firmlogin/fispoke', { replaceUrl: true });
      });
  }
}
